export default "__VITE_ASSET__Ckb_VA5K__"